










































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { formatCurrency } from "@/shared/currency";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class HsabInvestmentAccountPage extends Vue {
  formatCurrency = formatCurrency;

  hsabInvestmentStore = useHsabInvestmentStore();

  @Prop({ required: false }) username: string;

  @Prop({ required: false }) partnerId: number;

  mounted () {
    this.hsabInvestmentStore.loadInvestmentAccountStatus({ username: this.username, partnerId: this.partnerId });
  }

  get isLoaded () {
    return this.hsabInvestmentStore.investmentAccountStatusLoaded;
  }

  get investmentStatusClass () {
    return this.hsabInvestmentStore.hsabInvestmentsEnabled ? "text-primary" : "text-danger";
  }

  accountFields = [
    {
      key: "accountName",
      label: "Account Name"
    },
    {
      key: "accountBalance",
      label: "Account Balance",
      thClass: "text-right",
      tdClass: "text-right"
    }
  ];

  get accountItems () {
    return this.hsabInvestmentStore.hsabInvestmentAccounts.map(x => ({
      accountName: x.accountName,
      accountBalance: formatCurrency(x.accountBalance)
    }));
  }

  get numSlots () {
    return this.hsabInvestmentStore.hsabInvestmentsEnabled ? 2 : 1;
  }
}
